import { ListItemText, Menu, MenuItem } from "@mui/material";

import { BulkAction } from "../objectTree/utils/bulkActions";

export interface ContextMenuState {
    mouseX: number;
    mouseY: number;
    actions: BulkAction[];
}

export interface ContextMenuPopupProps {
    contextMenu: ContextMenuState | null;
    onClose: () => void;
}

export function ContextMenuPopup({ contextMenu, onClose }: ContextMenuPopupProps) {
    return (
        <Menu
            open={contextMenu !== null}
            onClose={onClose}
            anchorReference="anchorPosition"
            anchorPosition={contextMenu !== null ? { top: contextMenu.mouseY, left: contextMenu.mouseX } : undefined}
        >
            {contextMenu?.actions.map((action) => (
                <MenuItem key={action.id} onClick={action.onClick} disabled={action.disabled}>
                    <ListItemText>{action.label}</ListItemText>
                </MenuItem>
            ))}
        </Menu>
    );
}
